import { isDefined } from '@sgme/fp';
import { asIsoDate } from 'components/shared/DatePicker/utils';

import { now } from './now';

export const TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
export function toDateString(date: Date): string {
  return date.toISOString().substring(0, 10);
}

export function getTodayStringInLocalTimezone(): string {
  return asIsoDate(now());
}

export function isPastDate(date?: string): boolean | undefined {
  if (date === undefined) {
    return undefined;
  }
  const today = getTodayStringInLocalTimezone();
  return new Date(today) > new Date(date);
}

export function getDateStringInLocalTimezone(date: Date): string {
  return asIsoDate(date);
}

export function toStartOfDay(date: Date) {
  const startDate = new Date(date);
  startDate.setUTCHours(0, 0, 0, 0);
  startDate.setUTCMinutes(startDate.getTimezoneOffset(), 0, 0);
  startDate.setHours(0, 0, 0, 0);
  return startDate;
}

export function toEndOfDay(date: Date) {
  const endDate = new Date(date);
  endDate.setUTCHours(0, 0, 0, 0);
  endDate.setUTCMinutes(endDate.getTimezoneOffset(), 0, 0);
  endDate.setHours(23, 59, 59, 999);
  return endDate;
}

function getTemplate({ type, value }: Intl.DateTimeFormatPart) {
  switch (type) {
    case 'month':
      return 'MM';
    case 'day':
      return 'dd';
    case 'year':
      return 'yyyy';
    default:
      return value;
  }
}

export const getDateFormatTemplateString = (locale: string): string => {
  const parts = new Intl.DateTimeFormat(locale).formatToParts();
  return parts?.reduce((agg, part) => agg + getTemplate(part), '');
};

export function createUtcDateTime(limitDate?: string, limitTime?: string) {
  if (!isDefined(limitDate) || !isDefined(limitTime)) {
    return undefined;
  }
  const localLimitValidityDateTimeString = new Date(`${limitDate} ${limitTime}`);
  return localLimitValidityDateTimeString.toISOString();
}
export const xlDateTimeFormatOptions = {
  year: 'numeric' as const,
  month: 'short' as const,
  day: 'numeric' as const,
  hour: 'numeric' as const,
  minute: 'numeric' as const,
  second: 'numeric' as const,
};
